/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import { useSelector } from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import { Button } from 'react-bootstrap';

import * as constantMessageData from '../../../../SharedModules/Errors/constantMessageData';
import { convertQuatreManufacturer } from '../../../../SharedModules/CommonUtilities/commonUtilities';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import {
  autoFormateDate,
  checkActionAccessByRole,
} from '../../../../SharedModules/utilities/utilities';

export default function ManufacturerDetail(props) {
  const {
    showDefPaperFinalQTRErr,
    showDefCmsElectFinalQTRErr,
    showDefNcpSummaryFinalQtrErr,
    showDefNcpdpClaimMbFinalQTRErr,
    showDefPrintImageFinalQtrErr,
    showDefNcpdpClaimOwnFinalQTRErr,
    addEditReduxDataManufacturerTab,
    addEditManufacturerTabData,
    manufacturerDetail,
    setSuccessMessage,
    setManufacturerDetail,
    setDisabledSaveCancelBtn,
    commonDropdownList,
    isEnablebyRole,
  } = props;

  const { kcRoles } = useSelector((state) => state.sharedState.SharedReducer);
  const [
    {
      isDefPrintImageFinalQtrErr,
      isDefNcpdpClaimMbFinalQTRErr,
      isDefCmsElectFinalQTRErr,
      isDefNcpSummaryFinalQtrErr,
      isDefPaperFinalQTRErr,
      isDefNcpdpClaimOwnFinalQTRErr,
    },
    setShowError,
  ] = React.useState(false);

  // set default props values
  React.useEffect(() => {
    if (
      addEditManufacturerTabData &&
      Object.keys(addEditManufacturerTabData).length > 0
    ) {
      setShowError({
        isDefPrintImageFinalQtrErr:
          addEditManufacturerTabData.isDefPrintImageFinalQtrErr
            ? addEditManufacturerTabData.isDefPrintImageFinalQtrErr
            : false,
        isDefNcpdpClaimMbFinalQTRErr:
          addEditManufacturerTabData.isDefNcpdpClaimMbFinalQTRErr
            ? addEditManufacturerTabData.isDefNcpdpClaimMbFinalQTRErr
            : false,
        isDefCmsElectFinalQTRErr:
          addEditManufacturerTabData.isDefCmsElectFinalQTRErr
            ? addEditManufacturerTabData.isDefCmsElectFinalQTRErr
            : false,
        isDefNcpSummaryFinalQtrErr:
          addEditManufacturerTabData.isDefNcpSummaryFinalQtrErr
            ? addEditManufacturerTabData.isDefNcpSummaryFinalQtrErr
            : false,
        isDefPaperFinalQTRErr: addEditManufacturerTabData.isDefPaperFinalQTRErr
          ? addEditManufacturerTabData.isDefPaperFinalQTRErr
          : false,
        isDefNcpdpClaimOwnFinalQTRErr:
          addEditManufacturerTabData.isDefNcpdpClaimOwnFinalQTRErr
            ? addEditManufacturerTabData.isDefNcpdpClaimOwnFinalQTRErr
            : false,
      });
    }
  }, [addEditManufacturerTabData]);

  const generalSystemParameterDetails = useSelector((state) => {
    return state?.sharedState?.ManufacturerReducer?.generalSystemParameter
      ?.paramGeneralVO;
  });
  // call on change event filed level
  const handleOnChangeEvent = (e, name) => {
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
    setManufacturerDetail({
      ...manufacturerDetail,
      [name]: e.target.value,
    });
    addEditReduxDataManufacturerTab({
      ...addEditManufacturerTabData,
      disabledSaveCancelBtn: false,
      manufacturerDetail: {
        ...manufacturerDetail,
        [name]: e.target.value,
      },
    });
  };
  // call on blur event filed level
  const handleBlurEvent = async (e, name) => {
    const value = await autoFormateDate(manufacturerDetail[name]?.toUpperCase());
    //setTimeout(() => {
      setManufacturerDetail({
        ...manufacturerDetail,
        [name]: value,
      });
    //}, 1);
  };

  // call on click event radio filed level
  const handelCheckEvent = (e, name) => {
    if (!isEnablebyRole) {
      e.preventDefault(); // Prevent the default behavior of the checkbox if not enabled
      return;
    }
    const newObj = { ...manufacturerDetail };
    if (e.target.checked === undefined) {
      setManufacturerDetail({
        ...manufacturerDetail,
        [name]: newObj[name] === 0 ? 1 : 0,
      });
    } else {
      setManufacturerDetail({
        ...manufacturerDetail,
        [name]: e.target.checked ? 1 : 0,
      });
    }
    addEditReduxDataManufacturerTab({
      ...addEditManufacturerTabData,
      disabledSaveCancelBtn: false,
      manufacturerDetail: {
        ...manufacturerDetail,
        [name]: newObj[name] === 0 ? 1 : 0,
      },
    });
    setDisabledSaveCancelBtn(false);
    setSuccessMessage([]);
  };
  // set error message
  const errorMessagesArray = [...props.errorMessages];
  // remove error message
  const handleRemoveError = (value) => {
    if (!value) {
      errorMessagesArray &&
        errorMessagesArray.length > 0 &&
        errorMessagesArray.map((item, key) => {
          if (item === constantMessageData.QUARTER_FORMAT_ERROR) {
            return (
              errorMessagesArray.splice(key, 1),
              props.setErrorMessages([...new Set(errorMessagesArray)]),
              addEditReduxDataManufacturerTab({
                ...addEditManufacturerTabData,
                disabledSaveCancelBtn: false,
                errorMessages: [...new Set(errorMessagesArray)],
              })
            );
          }
        });
    }
  };
  // set common dropdown menu value
  const RenderDropDown = (items) => {
    return (
      <TextField
        id={items.id}
        name={items.name}
        label={items.label}
        disabled={items.disabled || !isEnablebyRole}
        fullWidth
        select
        placeholder=""
        inputProps={{ maxLength: 11, id: items.id }}
        InputLabelProps={{ shrink: true }}
        value={items.value}
        onChange={(e) => {
          handleOnChangeEvent(e, items.name);
        }}
      >
        <MenuItem key="" value="-1" className="frr-dropdown-blank-item" />
        {items.options && items.options.length > 0
          ? items.options.map((item) => {
              return (
                <MenuItem
                  key={item.codeValueID && item.codeValueID.codeValue}
                  value={item.codeValueID && item.codeValueID.codeValue}
                >
                  {`${item.codeValueID && item.codeValueID.codeValue} | ${
                    item.shortDescription
                  }`}
                </MenuItem>
              );
            })
          : null}
      </TextField>
    );
  };
  return (
    <div data-testid="mfg-detail" className="">
      <div className="form-wrapper">
        <div className="mui-custom-form input-md">
          <div className="sub-checkbox">
            <FormControlLabel
              data-testid="rebatewebParticipantInd"
              control={
                <Checkbox
                  style={{ margin: '5px' }}
                  color="primary"
                  disabled={!isEnablebyRole}
                />
              }
              label="  Rebate Web participant"
              checked={manufacturerDetail.rebatewebParticipantInd === 1}
              value={manufacturerDetail.rebatewebParticipantInd === 1}
              onClick={(e) => {
                handelCheckEvent(e, 'rebatewebParticipantInd');
              }}
              disabled={!isEnablebyRole}
            />
          </div>
        </div>
      </div>
      <fieldset
        className="custom-fieldset d-flex flex-column flex-sm-row"
        style={{ height: 'auto' }}
      >
        <legend className="same-font-family">Defaults</legend>
        <div className="col-12 col-sm-4 pl-0">
          {checkActionAccessByRole(
            process.env.REACT_APP_HIDE_ACCESS_ROLES,
            kcRoles
          ) && (
            <fieldset className="custom-fieldset" style={{ height: 'auto' }}>
              <legend className="same-font-family">Timing Codes</legend>
              <div className="form-wrapper">
                <div className="mui-custom-form with-select field-xl mfg-dropdown">
                  <RenderDropDown
                    data-testid="Enrollment"
                    label="Enrollment"
                    id="Enrollment"
                    name="defEnrollmentTimingCd"
                    disabled={false}
                    value={manufacturerDetail.defEnrollmentTimingCd}
                    options={commonDropdownList.ENROLLMENT_TIMING_CD}
                  />
                </div>

                <div className="mui-custom-form with-select field-xl mfg-dropdown">
                  <RenderDropDown
                    data-testid="Pricing"
                    label="Pricing"
                    id="Pricing"
                    name="defPricingTimingCd"
                    disabled={false}
                    value={manufacturerDetail.defPricingTimingCd}
                    options={commonDropdownList.PRICING_TIMING_CD}
                  />
                </div>
              </div>
            </fieldset>
          )}

          <div className="form-wrapper">
            <div className="mui-custom-form input-md field-xl">
              <TextField
                data-testid="WAC_percent"
                id="WAC_percent"
                label="WAC Percent"
                fullWidth
                placeholder=""
                disabled={
                  generalSystemParameterDetails?.[0]?.drugGrossAmtInd !== 1 ||
                  !isEnablebyRole
                }
                InputLabelProps={{ shrink: true }}
                inputProps={{ maxLength: 11 }}
                value={manufacturerDetail.defWacPct}
                onChange={(e) => {
                  handleOnChangeEvent(e, 'defWacPct');
                }}
              />
            </div>
            {checkActionAccessByRole(
              process.env.REACT_APP_HIDE_ACCESS_ROLES,
              kcRoles
            ) && (
              <div className="mui-custom-form with-select field-xl">
                <RenderDropDown
                  data-testid="Collection_Medium"
                  label="Collection Medium"
                  id="Collection_Medium"
                  name="defCollectionMediumCd"
                  disabled={false}
                  value={manufacturerDetail.defCollectionMediumCd}
                  options={commonDropdownList.COLLECTION_MEDIUM_CD}
                />
              </div>
            )}
          </div>
        </div>
        <div className="col-12 col-sm-8 pr-0 pl-0">
          <fieldset className="custom-fieldset px-0" style={{ height: 'auto' }}>
            <legend className="same-font-family">Desired Outputs</legend>
            <div className="form-wrapper chk-input">
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  data-testid="Paper"
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="Paper"
                  checked={manufacturerDetail.defPaperInd === 1}
                  value={manufacturerDetail.defPaperInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defPaperInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  data-testid="DEF_PAPER_FINAL"
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="DEF_PAPER_FINAL_QTR"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defPaperFinalQtr}
                  disabled={manufacturerDetail.defPaperInd !== 1 || !isEnablebyRole}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defPaperFinalQtr');
                  }}
                  onBlur={(e) => {
                    let isDefPaperFinalQTRErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefPaperFinalQTRErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefPaperFinalQTRErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defPaperFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  helperText={
                    showDefPaperFinalQTRErr || isDefPaperFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefPaperFinalQTRErr || isDefPaperFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="CMS Format Electronic File"
                  data-testid="defCmsElectInd"
                  checked={manufacturerDetail.defCmsElectInd === 1}
                  value={manufacturerDetail.defCmsElectInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defCmsElectInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="DEF_CMS_ELECT_FINAL_QTR"
                  data-testid="DEF_CMS_ELECT_FINAL_QTR"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defCmsElectFinalQtr}
                  disabled={manufacturerDetail.defCmsElectInd != 1 || !isEnablebyRole}
                  onBlur={(e) => {
                    let isDefCmsElectFinalQTRErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefCmsElectFinalQTRErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefCmsElectFinalQTRErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defCmsElectFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defCmsElectFinalQtr');
                  }}
                  helperText={
                    showDefCmsElectFinalQTRErr || isDefCmsElectFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefCmsElectFinalQTRErr || isDefCmsElectFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
            </div>
            <div className="form-wrapper chk-input">
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="NCPDP Summary"
                  data-testid="defNcpdpSummaryInd"
                  checked={manufacturerDetail.defNcpdpSummaryInd === 1}
                  value={manufacturerDetail.defNcpdpSummaryInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defNcpdpSummaryInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="DEF_NCPDP_SUMMARY_FINAL_QTR"
                  data-testid="DEF_NCPDP_SUMMARY_FINAL_QTR"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defNcpdpSummaryFinalQtr}
                  disabled={manufacturerDetail.defNcpdpSummaryInd !== 1 || !isEnablebyRole}
                  onBlur={(e) => {
                    let isDefNcpSummaryFinalQtrErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefNcpSummaryFinalQtrErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefNcpSummaryFinalQtrErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defNcpdpSummaryFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defNcpdpSummaryFinalQtr');
                  }}
                  helperText={
                    showDefNcpSummaryFinalQtrErr || isDefNcpSummaryFinalQtrErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefNcpSummaryFinalQtrErr || isDefNcpSummaryFinalQtrErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="NCPDP Own Claims Detail"
                  data-testid="defNcpdpClaimOwnInd"
                  checked={manufacturerDetail.defNcpdpClaimOwnInd === 1}
                  value={manufacturerDetail.defNcpdpClaimOwnInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defNcpdpClaimOwnInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="DEF_NCPDP_CLAIM_OWN_FINAL_QTR"
                  data-testid="DEF_NCPDP_CLAIM_OWN_FINAL_QTR"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defNcpdpClaimOwnFinalQtr}
                  disabled={manufacturerDetail.defNcpdpClaimOwnInd !== 1 || !isEnablebyRole}
                  onBlur={(e) => {
                    let isDefNcpdpClaimOwnFinalQTRErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefNcpdpClaimOwnFinalQTRErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefNcpdpClaimOwnFinalQTRErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defNcpdpClaimOwnFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defNcpdpClaimOwnFinalQtr');
                  }}
                  helperText={
                    showDefNcpdpClaimOwnFinalQTRErr ||
                    isDefNcpdpClaimOwnFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefNcpdpClaimOwnFinalQTRErr ||
                    isDefNcpdpClaimOwnFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
            </div>
            <div className="form-wrapper chk-input">
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="Print Image"
                  data-testid="defPrintImageInd"
                  checked={manufacturerDetail.defPrintImageInd === 1}
                  value={manufacturerDetail.defPrintImageInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defPrintImageInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="defPrintImageFinalQtr"
                  data-testid="defPrintImageFinalQtr"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defPrintImageFinalQtr}
                  disabled={manufacturerDetail.defPrintImageInd !== 1 || !isEnablebyRole}
                  onBlur={(e) => {
                    let isDefPrintImageFinalQtrErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefPrintImageFinalQtrErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefPrintImageFinalQtrErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defPrintImageFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defPrintImageFinalQtr');
                  }}
                  helperText={
                    showDefPrintImageFinalQtrErr || isDefPrintImageFinalQtrErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefPrintImageFinalQtrErr || isDefPrintImageFinalQtrErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
              <div className="mui-custom-form input-md field-md">
                <FormControlLabel
                  control={
                    <Checkbox color="primary" disabled={!isEnablebyRole} />
                  }
                  label="NCPDP Market Basket Claims Detail"
                  data-testid="defNcpdpClaimMbInd"
                  checked={manufacturerDetail.defNcpdpClaimMbInd === 1}
                  value={manufacturerDetail.defNcpdpClaimMbInd === 1}
                  onClick={(e) => {
                    handelCheckEvent(e, 'defNcpdpClaimMbInd');
                  }}
                  disabled={!isEnablebyRole}
                />
                <TextField
                  className="manufacture-margin mandate-fields frr-display-hidden-label"
                  id="DEF_NCPDP_CLAIM_MB_FINAL_QTR"
                  data-testid="DEF_NCPDP_CLAIM_MB_FINAL_QTR"
                  label=" "
                  fullWidth
                  placeholder=""
                  inputProps={{ maxLength: 6 }}
                  InputLabelProps={{ shrink: true }}
                  required
                  value={manufacturerDetail.defNcpdpClaimMbFinalQtr}
                  disabled={manufacturerDetail.defNcpdpClaimMbInd !== 1 || !isEnablebyRole}
                  onBlur={(e) => {
                    let isDefNcpdpClaimMbFinalQTRErr = false;
                    if (
                      e.target.value !== '' &&
                      e.target.value.length > 0 &&
                      !convertQuatreManufacturer(e.target.value?.trim())
                    ) {
                      errorMessagesArray.push(
                        constantMessageData.QUARTER_FORMAT_ERROR
                      );
                      isDefNcpdpClaimMbFinalQTRErr = true;
                      handleRemoveError(true);
                    } else {
                      isDefNcpdpClaimMbFinalQTRErr = false;
                      handleRemoveError(false);
                      handleBlurEvent(e, 'defNcpdpClaimMbFinalQtr');
                    }
                    setShowError({
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                    });
                    props.setErrorMessages([...new Set(errorMessagesArray)]);
                    addEditReduxDataManufacturerTab({
                      ...addEditManufacturerTabData,
                      isDefPrintImageFinalQtrErr,
                      isDefNcpdpClaimMbFinalQTRErr,
                      isDefCmsElectFinalQTRErr,
                      isDefNcpSummaryFinalQtrErr,
                      isDefPaperFinalQTRErr,
                      isDefNcpdpClaimOwnFinalQTRErr,
                      errorMessages: [...new Set(errorMessagesArray)],
                    });
                  }}
                  onChange={(e) => {
                    handleOnChangeEvent(e, 'defNcpdpClaimMbFinalQtr');
                  }}
                  helperText={
                    showDefNcpdpClaimMbFinalQTRErr ||
                    isDefNcpdpClaimMbFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                  error={
                    showDefNcpdpClaimMbFinalQTRErr ||
                    isDefNcpdpClaimMbFinalQTRErr
                      ? constantMessageData.QUARTER_FORMAT_ERROR
                      : null
                  }
                />
              </div>
            </div>
          </fieldset>
        </div>
      </fieldset>
    </div>
  );
}
